"use strict";
//@ts-nocheck
/*global $*/
/*global window*/
/*global document*/
/*global console*/
/*global setTimeout*/
/*global jRespond*/
/*global TYPO3*/
Object.defineProperty(exports, "__esModule", { value: true });
(function () {
    'use strict';
    // Create global objects
    window.gs1 = window.gs1 || {};
    TYPO3.lang = TYPO3.lang || {};
    TYPO3.settings = TYPO3.settings || {};
    var exports = {
        initializeErrorMessageHandling: function () {
            $('.dqx-order-form').find('.mandatory-message').find('a').on('click', function (event) {
                event.preventDefault();
                var $anchor = $(this);
                var $targetElement = $($anchor.attr('href'));
                var targetOffset = $targetElement.offset().top;
                $('html,body').animate({
                    scrollTop: targetOffset
                }, 500, function () {
                    $targetElement.trigger('focus');
                    $targetElement.trigger('select');
                });
            });
        },
        /**
         * Attaches event handlers to the order form submit functionality.
         * Disables the submit button initially, checks requirement triggers for billing
         * and service contact sections, resets form values if sections are not required,
         * and then submits the form.
         *
         * @private
         * @returns {void}
         */
        attachSubmitFormEvents: function () {
            const orderForm = document.forms["order"];
            if (orderForm) {
                orderForm.addEventListener("submit", function (e) {
                    e.preventDefault();
                    const form = this;
                    const submitBtn = form.querySelector('[type="submit"]');
                    // Disable submit button (prevent »double click« duplicate submits)
                    submitBtn.disabled = true;
                    const billingContactIsRequiredElement = document.getElementById('billing_contact_required');
                    if (billingContactIsRequiredElement) {
                        if (document.getElementById('billing_contact_required').value == 0) {
                            exports.resetFormElementValuesByIdPrefix('billingContact.');
                        }
                    }
                    const serviceContactIsRequiredElement = document.getElementById('service_contact_required');
                    if (serviceContactIsRequiredElement) {
                        if (document.getElementById('service_contact_required').value == 0) {
                            exports.resetFormElementValuesByIdPrefix('serviceContact.');
                        }
                    }
                    form.submit();
                });
            }
        },
        /**
         * Attaches a click event listener to the billing contact toggle button.
         * When clicked, the function toggles the visibility of the billing contact section,
         * updates the button text based on the current state, and manages the
         * billing contact requirement trigger value.
         *
         * The function also resets form element values with a specific prefix when
         * the section is hidden.
         */
        attachSectionToggleBillingContactEvent: function () {
            this.toggleSection('section-toogle-billing-contact', 'section-billing-contact', 'billing_contact_required', 'billingContact.');
        },
        /**
         * Attaches a click event listener to the service contact toggle button.
         * When clicked, the function toggles the visibility of the service contact section,
         * updates the button text based on the current state, and manages the
         * service contact requirement trigger value.
         *
         * The function also resets form element values with a specific prefix when
         * the section is hidden.
         */
        attachSectionToggleServiceContactEvent: function () {
            this.toggleSection('section-toogle-service-contact', 'section-service-contact', 'service_contact_required', 'serviceContact.');
        },
        /**
         * Toggles the visibility of a section and updates related UI elements.
         *
         * @param {string} toggle - The ID of the toggle button element
         * @param {string} section - The ID of the section element to be toggled
         * @param {string} statusElement - The ID of the status element that tracks the section state
         * @param {string} idPrefix - The prefix used to identify form elements to reset when section is closed
         * @return {void}
         */
        toggleSection: function (toggle, section, statusElement, idPrefix) {
            const btn = document.getElementById(toggle);
            const panel = document.getElementById(section);
            const sectionRequirementTrigger = document.getElementById(statusElement);
            const t = (key, fallback = '') => (window.TYPO3 && TYPO3.lang && TYPO3.lang[key]) || fallback;
            if (btn !== null) {
                btn.addEventListener('click', () => {
                    event.preventDefault();
                    panel.classList.toggle('open');
                    if (panel.classList.contains('open')) {
                        btn.textContent = t('js.form.toggle.hide', 'entfernen');
                        sectionRequirementTrigger.value = 1;
                    }
                    else {
                        btn.textContent = t('js.form.toggle.show', 'hinzufügen');
                        sectionRequirementTrigger.value = 0;
                        this.resetFormElementValuesByIdPrefix(idPrefix);
                    }
                });
            }
        },
        /**
         * Resets the values of form elements that have IDs starting with the specified prefix.
         *
         * @param {string} idPrefix - The prefix string used to identify form elements to reset
         * @return {void}
         */
        resetFormElementValuesByIdPrefix: function (idPrefix) {
            document.querySelectorAll('[id^="' + idPrefix + '"]').forEach(el => {
                // Reset inputs
                if (el.type === "text" || el.type === "textarea" || el.type === "number" || el.type === "email" || el.type === "tel") {
                    el.value = "";
                }
                // Reset checkboxes/radiobuttons
                if (el.type === "checkbox" || el.type === "radio") {
                    el.checked = false;
                }
                // Reset selects
                if (el.tagName === "SELECT") {
                    el.selectedIndex = 0;
                }
            });
        }
    };
    exports.initializeErrorMessageHandling();
    exports.attachSubmitFormEvents();
    exports.attachSectionToggleBillingContactEvent();
    exports.attachSectionToggleServiceContactEvent();
})();
